import { render, staticRenderFns } from "./1_PersonalDetails.vue?vue&type=template&id=61f6ca26&scoped=true&"
import script from "./1_PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./1_PersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./1_PersonalDetails.vue?vue&type=style&index=0&id=61f6ca26&lang=scss&scoped=true&"
import style1 from "./1_PersonalDetails.vue?vue&type=style&index=1&id=61f6ca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6ca26",
  null
  
)

export default component.exports